import { authApiDetailType } from '../../../../templates/default/Auth/API/request/authApiDetailType'
import { requests } from '../../../RestFullApi/api'

export const dynamik = {
    getAPostModuls: (): Promise<authApiDetailType[]> =>
        requests.get(`dynamikModul/all/`),
    getAPostSitemap: (): Promise<authApiDetailType[]> =>
        requests.get(`dynamikSitemap/all/`)
}
